var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowSlideRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:round-navigate-next"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.3954 14.4792C19.2023 14.6719 19.049 14.9009 18.9445 15.1529C18.8399 15.4049 18.7861 15.6751 18.7861 15.9479C18.7861 16.2208 18.8399 16.491 18.9445 16.743C19.049 16.995 19.2023 17.224 19.3954 17.4167L27.4787 25.5L19.3954 33.5834C19.0059 33.9729 18.787 34.5012 18.787 35.0521C18.787 35.603 19.0059 36.1313 19.3954 36.5209C19.7849 36.9104 20.3133 37.1292 20.8641 37.1292C21.415 37.1292 21.9434 36.9104 22.3329 36.5209L31.8954 26.9584C32.0885 26.7656 32.2417 26.5367 32.3463 26.2847C32.4508 26.0326 32.5046 25.7625 32.5046 25.4896C32.5046 25.2168 32.4508 24.9466 32.3463 24.6946C32.2417 24.4425 32.0885 24.2136 31.8954 24.0209L22.3329 14.4584C21.5412 13.6667 20.2079 13.6667 19.3954 14.4792Z",
    fill: "#004F9D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowSlideRight);
export default __webpack_public_path__ + "static/media/icon_arrow_slide_right.6fb0986a9f9c09ddb9169bb1ef9f3a3e.svg";
export { ForwardRef as ReactComponent };